(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoLicController', ReporteEvaluativoLicController);

    ReporteEvaluativoLicController.$inject = ['$scope', '$state', '$stateParams','ReporteEvaluativoLicService', 'ReporteEvaluativoLicRegenerarService','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoLicController ($scope, $state, $stateParams,ReporteEvaluativoLicService, ReporteEvaluativoLicRegenerarService,ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.round=round;
        vm.save=save;
        vm.autoheight=autoheight;
        vm.print=print;
        
		
		function calculateContentHeight( ta, scanAmount ) {
		    var origHeight = ta.style.height,
		        height = ta.offsetHeight,
		        scrollHeight = ta.scrollHeight,
		        overflow = ta.style.overflow;
		    /// only bother if the ta is bigger than content
		    if ( height >= scrollHeight ) {
		        /// check that our browser supports changing dimension
		        /// calculations mid-way through a function call...
		        ta.style.height = (height + scanAmount) + 'px';
		        /// because the scrollbar can cause calculation problems
		        ta.style.overflow = 'hidden';
		        /// by checking that scrollHeight has updated
		        if ( scrollHeight < ta.scrollHeight ) {
		            /// now try and scan the ta's height downwards
		            /// until scrollHeight becomes larger than height
		            while (ta.offsetHeight >= ta.scrollHeight) {
		                ta.style.height = (height -= scanAmount)+'px';
		            }
		            /// be more specific to get the exact height
		            while (ta.offsetHeight < ta.scrollHeight) {
		                ta.style.height = (height++)+'px';
		            }
		            /// reset the ta back to it's original height
		            ta.style.height = origHeight;
		            /// put the overflow back
		            ta.style.overflow = overflow;
		            return height;
		        }
		    } else {
		        return scrollHeight;
		    }
		}
		
		function autoheight(element) {
			var rows = 1;
//			console.log("Hola");
//			var el = document.getElementById(element);
//		    el.style.height = "5px";
//		    el.style.height = (el.scrollHeight)+"px";

			var ta = document.getElementById(element),
			style = (window.getComputedStyle) ?
			window.getComputedStyle(ta) : ta.currentStyle,
			
			// This will get the line-height only if it is set in the css,
			// otherwise it's "normal"
			taLineHeight = parseInt(style.lineHeight, 10),
			// Get the scroll height of the textarea
			taHeight = calculateContentHeight(ta, taLineHeight),
			// calculate the number of lines
			rows = Math.ceil(taHeight / taLineHeight);
			
//			document.getElementById("lines").innerHTML = "there are " +
//			rows + " lines in the text area";
//			console.log(rows);
			return rows;
		}
		
		
		
        function round(valor){
        	return Math.round(valor);
        }
        
        function print(){
        	window.print();
        }
		
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoLicRegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoLicService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoLicService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
        }
		
        function onSaveSuccess (result) {
            $scope.$emit('sideApp:reporte', result);
            vm.isSaving = false;
			if(vm.wrapper.tipoUser==1){
				 $state.go('generarReporteLic', 
					{
					 	idA: $stateParams.idA,
			 			idP: $stateParams.idP,
			 			idAnio: $stateParams.idAnio,
			 			idIndice: $stateParams.idIndice,
			 			ic: $stateParams.ic,
			            iic: $stateParams.iic,
			 			tipoEvaluacion: $stateParams.tipoEvaluacion,
			 			idDependencia: $stateParams.idDependencia,
			 			nivell: $stateParams.nivell,
			 			modeloo: $stateParams.modeloo
					},
					{ reload: true });
			}else{
				if(vm.wrapper.tipoUser==2){
			        $state.go('revisionReporteLic', null, { reload: true });
			    }
			}	
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'iteraccion',
    			type: 'bar'
            },
            title: {
                text: 'Estrategias de enseñanza y aprendizaje'
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: 
            	[
					'1. Establece actividades de aprendizaje donde se relacionan conocimientos nuevos con previos',
					'2. Utiliza actividades de aprendizaje que promueven el análisis de los contenidos',
					'3. Implementa actividades que aportan experiencia para el campo laboral',
					'4. Considera actividades que permiten ver la utilidad de la asignatura',
					'5. Utiliza actividades que desarrollan las competencias de la asignatura'
            	],
                type: 'integer'
            },
			tooltip: {
			    valueSuffix: '%'
			},
			plotOptions: {
			    bar: {
			        dataLabels: {
			            enabled: true,
						format: '{y}%'
			        }
			    },
			},
			series: 
			[
			    {
			         name: 'Estudiantes',
			         data: [
			            Math.round(vm.reporte.estraenzapren1_e),
			         	Math.round(vm.reporte.estraenzapren2_e), 
			         	Math.round(vm.reporte.estraenzapren3_e),
			         	Math.round(vm.reporte.estraenzapren4_e),
			         	Math.round(vm.reporte.estraenzapren5_e)
			            ],
			        	color: '#002e5f'
			     }
			]
        });

        var chart2 = new Highcharts.Chart({
            chart: {
                renderTo: 'estrategias',
    			type: 'bar'
            },
            title: {
                text: 'Estrategias de evaluación'
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: [
					'6. Explica los requisitos y valor de cada actividad, al solicitarla',
					'7. Utiliza instrumentos para evaluar las actividades (rúbrica, listas de cotejo, de verificación, etc.)',
					'8. Informa la puntuación obtenida, encada una de las actividades realizadas',
					'9. Retroalimenta el progreso académico, señalando fortalezas y áreas de mejora'
            		],
                type: 'integer'
            },
			tooltip: {
			    valueSuffix: '%'
			},
			plotOptions: {
			    bar: {
			        dataLabels: {
			            enabled: true,
						format: '{y}%'
			        }
			    },
			},
            series: 
			[
				{
                	name: 'Estudiantes',
	                data: [
						Math.round(vm.reporte.estraevprom6_e),
	                	Math.round(vm.reporte.estraevprom7_e), 
	                	Math.round(vm.reporte.estraevprom8_e),
	                	Math.round(vm.reporte.estraevprom9_e)
					],
	               	color: '#002e5f'
            	}
			]
        });
        var chart3 = new Highcharts.Chart({
            chart: {
                renderTo: 'materias',
    			type: 'bar'
            },
            title: {
                text: ''
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: 
            	[
					'Dominio de contenidos',
					'Forma de evaluar',
					'Forma de trabajo en la asignatura',
					'Materiales de apoyo',
					'Planeación de la asignatura',
					'Relaciones con el grupo',
					'Utilidad para el campo laboral',
					'Conducta ética y profesional',
					'No brindaron recomendaciones'
            	],
                type: 'integer'
            },
			tooltip: {
				valueSuffix: '%'
			},
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
						format: '{y}%'
                    }
                },
            },
            series: 
			[
				{
	                name: 'Estudiantes',
	                data: 
	                [
						vm.reporte.domicont_e,
						vm.reporte.formaev_e,
						vm.reporte.formtrbasig_e,
						vm.reporte.matapoy_e,
						vm.reporte.planasig_e,
						vm.reporte.relagrpo_e,
						vm.reporte.uticamplab_e,
						vm.reporte.conduceticyprof_e,
						vm.reporte.norecomen_e
	                ],
	               	color: '#002e5f'
            	}
			]
        });
    }
})();
